var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 100,
    viewBox: "0 0 108 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "World "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M103.041 0H29.8572C27.3316 0 25.2842 2.05166 25.2842 4.58251V25L67.6966 37.5L107.614 25V4.58251C107.614 2.05166 105.567 0 103.041 0Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M107.614 25H25.2842V50L67.6966 57.5L107.614 50V25Z",
    fill: "#2B7CD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.2842 50V75L65.2018 80L107.614 75V50H25.2842Z",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.8572 100H103.041C105.567 100 107.614 97.9483 107.614 95.4175V75H25.2842V95.4175C25.2842 97.9483 27.3316 100 29.8572 100Z",
    fill: "#103F91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.1,
    d: "M55.639 20H25.2842V82.5H55.639C58.1612 82.4918 60.2038 80.4449 60.2121 77.9175V24.5825C60.2038 22.0551 58.1612 20.0082 55.639 20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M53.1441 22.5001H25.2842V85.0001H53.1441C55.6664 84.9919 57.709 82.945 57.7172 80.4176V27.0826C57.709 24.5552 55.6664 22.5084 53.1441 22.5001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M53.1441 22.5001H25.2842V80.0001H53.1441C55.6664 79.9919 57.709 77.945 57.7172 75.4176V27.0826C57.709 24.5552 55.6664 22.5084 53.1441 22.5001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    d: "M50.6493 22.5001H25.2842V80.0001H50.6493C53.1715 79.9919 55.2141 77.945 55.2224 75.4176V27.0826C55.2141 24.5552 53.1715 22.5084 50.6493 22.5001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.90852 22.5001H50.649C53.1747 22.5001 55.2221 24.5518 55.2221 27.0826V72.9177C55.2221 75.4485 53.1747 77.5002 50.649 77.5002H4.90852C2.38288 77.5002 0.335449 75.4485 0.335449 72.9177V27.0826C0.335449 24.5518 2.38288 22.5001 4.90852 22.5001Z",
    fill: "url(#paint0_linear_1_5216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.1017 57.6451C19.1915 58.3526 19.2514 58.9676 19.2788 59.4951H19.3836C19.4235 58.9951 19.5066 58.3926 19.6331 57.6876C19.7595 56.9826 19.8734 56.3867 19.9749 55.9001L24.7849 35.1051H31.0046L35.9943 55.5876C36.2842 56.8612 36.4917 58.1522 36.6155 59.4526H36.6979C36.7909 58.1927 36.9642 56.9402 37.2168 55.7026L41.1961 35.0951H46.8569L39.8663 64.8951H33.2525L28.5123 45.1601C28.3751 44.5926 28.2179 43.8501 28.0457 42.9375C27.8736 42.025 27.7663 41.3575 27.7239 40.9375H27.6416C27.5867 41.4225 27.4794 42.1426 27.3197 43.0975C27.16 44.0526 27.032 44.7592 26.9355 45.2176L22.4796 64.8901H15.7535L8.72559 35.105H14.4887L18.8222 55.9425C18.9196 56.3701 19.0119 56.9401 19.1017 57.6451Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5216",
    x1: 9.87037,
    y1: 18.9195,
    x2: 45.7981,
    y2: 81.0166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/wordIcon.0f382181ed27e4c491980488e1f45f30.svg";
export { ForwardRef as ReactComponent };